import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import {
  BioContainer,
  ProfilePictureContainer,
  BioDescription,
  OrangeLinkNoVisited,
} from "./styles"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query {
      profilePicture: file(relativePath: { eq: "profilepic.png" }) {
        childImageSharp {
          fixed(height: 100, width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <BioContainer>
      <ProfilePictureContainer>
        <Img
          fixed={data.profilePicture.childImageSharp.fixed}
          alt="Anumitha Apollo"
          imgStyle={imageStyle}
        />
      </ProfilePictureContainer>
      <BioDescription>
        Personal blog by{" "}
        <OrangeLinkNoVisited to="/blog/">Anumitha Apollo</OrangeLinkNoVisited>
        <br /> I write about what I learn and things
        <br /> of my interest.
      </BioDescription>
    </BioContainer>
  )
}

const imageStyle = {
  borderRadius: "50%",
}

export default Bio
